import Plausible from 'plausible-tracker';
import { useEffect, type ReactNode } from 'react';

export default function PlausibleAnalytics({
  children,
}: {
  children: ReactNode;
}) {
  useEffect(() => {
    const plausible = Plausible({
      domain: 'app.hooklistener.com',
      apiHost: 'https://ps.lemonity.com',
    });

    // Enable automatic page view tracking
    const enableAutoPageviews = plausible.enableAutoPageviews();

    return () => {
      // Cleanup by disabling automatic page view tracking
      enableAutoPageviews();
    };
  }, []);

  return <>{children}</>;
}
